// Issue #289: 英語ロケール用ファイル。
// App.js の i18n ローダは "en/ ファイルが存在すれば en/ を採用、無ければ ja/ にフォールバック" するため、
// 部分定義だけだと未訳キーが undefined になり画面全体が壊れる。
// 対策として ja/ をベースに展開し、Issue #289 で追加した英語訳のみ上書きする。
import jaBody from '../../ja/Elements/Body';

export default {
    ...jaBody,

    AccountInfoTitle: "Account information",
    // Issue #289: Account name editing
    AccountExternalNumberDescriptionTitle: "External Number Name Settings",
    AccountExternalNumberDescriptionLabel: "Name",
    AccountExternalNumberDescriptionPlaceholder: "e.g. Sales Dept.",
    AccountExternalNumberNumber: "External Number",
    AccountExternalNumberDescriptionSummary: "External numbers: {0} / Named: {1}",
    AccountExternalNumberDescriptionNote: "The name appears next to the external number in the call history list, search results and CSV. Enter a department name, for example.",
    AccountExternalNumberDescriptionSaveNote: "This dialog has no save button. After closing it, save your input with Confirm and then Set at the bottom of the screen.",
    AccountNotSet: "Not set",
    AccountCurrentPassword: "Current password",
    AccountReauthNote: "Enter your current password to change the email address or two-factor authentication.",
    AccountReauthModalTitle: "Identity verification",
    AccountMfaChangeReauthNote: "Enter your current password to change the two-factor authentication setting.",

    // Issue #289: Record search
    ExternalNumberSearchPlaceholder: "Select external numbers (multiple allowed)",
    ExternalNumberSearchNoOptions: "No external numbers found",

    // Issue #443: Email OTP multi-factor authentication
    MfaTitle: "Two-factor authentication",
    MfaDescription: "A verification code has been sent to {0}.",
    MfaCodePlaceholder: "Verification code (6 digits)",
    MfaRemainingTime: "Expires in: {0}",
    MfaExpired: "The verification code has expired. Please resend it.",
    MfaRemainingAttempts: "Remaining attempts: {0}",
    MfaVerify: "Verify",
    MfaVerifying: "Verifying...",
    MfaResend: "Resend verification code",
    MfaResendWait: "Resend available in {0} sec.",
    MfaResendRemaining: "Remaining resends: {0}",
    MfaBackToLogin: "Back to login",

    // Issue #443: Account settings
    MfaSettingSubUserTitle: "Two-factor authentication for sub users",
    MfaSettingSubUserMail: "Destination email address",
    MfaSettingSubUserMailUnset: "If not set, the code is sent to the parent user's email address.",
    MfaSettingSubUserMailUnsetShort: "Not set (sent to the parent user)",
    MfaSettingSubUserMailPlaceholder: "e.g. sub-user@example.co.jp",
    MfaSettingSubUserMailInvalid: "The email address format is invalid.",
    MfaSettingSubUserAfterSave: "Available after the sub user is created",
    MfaSettingEnable: "Enable two-factor authentication",

    // Account: re-authentication UI for changing the email address
    AccountMailChangeReauthNote: "Enter your current password to change the email address.",
    AccountMailChangeSubUserNote: "Only the parent user can change the email address.",
    AccountMailChangeMfaNote: "Two-factor authentication is enabled. After this change, login verification codes will be sent to the new email address. Make sure the address is one you can receive mail at, otherwise you will not be able to log in.",

    // Issue #443: User management
    MfaStatus: "Two-factor auth",
    MfaStatusOn: "Enabled",
    MfaStatusOff: "Disabled",
    // 【#586】アカウント管理の二要素認証の説明
    AccountMfaDescOn: "A verification code is sent to {0} every time you log in.",
    AccountMfaDescOff: "When enabled, you will enter a verification code sent by email when logging in.",
    MfaOffButton: "Turn off",
    MfaOffTitle: "Disable two-factor authentication",
    MfaOffConfirmMessage: "Disable two-factor authentication for {0}. Are you sure?",
    MfaOffNote: "* Administrators cannot enable it. Users enable it from their account page.",

    // 保存が一部だけ失敗したときに、どれが失敗したかを伝えるための項目名
    UserInfo: "Account information",

    // 【#589】録音再生モーダルの通話概要の折りたたみ
    ShowAll: "Show all",
    ShowLess: "Show less",

    // 【#586】アカウント管理画面の区分見出し・入力誤りの説明・サブユーザー上限
    AccountSections: {
        basic: "Basic information",
        security: "Login & security",
        sub_user: "Sub-users",
        recording: "Recording & audio",
        external_number: "External numbers",
    },
    AccountValidationMailInvalid: "The email address format is invalid.",
    AccountValidationTelInvalid: "Enter the phone number as 10 to 11 digits only (no hyphens).",
    AccountValidationPasswordPolicy: "Use at least 8 characters including letters and numbers.",
    AccountValidationPasswordRequired: "Enter a password.",
    AccountValidationCurrentPasswordRequired: "Enter your current password.",
    AccountValidationPasswordMismatch: "The new password and confirmation do not match.",
    AccountValidationSummary: "There are input errors (check the fields outlined in red).",
    AccountSubUserCount: "Sub-users ({0} / limit {1})",
    AccountSubUserLimitReached: "The limit has been reached; no more can be added.",

    // 【#586】アカウント管理のメールアドレス未入力（ja には既存）
    EmailAddressRequired: "Email address is required.",

    // 【#590】ユーザー一覧の所有デバイス列
    OtherCount: "+{count} more",
}
